interface IBackIconProps {
  width?: number;
  height?: number;
}

export default function BackIcon({ width, height }: IBackIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? 15.809}
      height={height ?? 27.118}
      viewBox="0 0 15.809 27.118">
      <g id="Icons_Arrows_Left" transform="translate(0.75 1.059)">
        <path
          id="Path"
          d="M14,25,0,12.5,14,0"
          fill="none"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  );
}
